import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useDetailOrderHistory, useOrderStatus } from "hooks/order/useOrder";
import moment from "moment";
import React, { useEffect } from "react";

const OrderHistoryList = ({ orderId }) => {
  const {
    refetch: fetchOrderHistoryList,
    data: orderHistoryList,
    isLoading: isOrderHistoryLoading,
  } = useDetailOrderHistory({
    orderId: orderId,
  });
  const { refetch: fetchOrderStatusList, data: orderStatusList } =
    useOrderStatus();

  useEffect(() => {
    if (orderId) {
      fetchOrderHistoryList();
      fetchOrderStatusList();
    }
  }, [orderId]);

  const columnTable = [
    {
      dataField: "no",
      text: "#",
      formatter: (cell, row, enumObject) => {
        return `${enumObject + 1}`;
      },
    },
    {
      dataField: "maker_date",
      text: "Thời gian",
      formatter: (cell, row, enumObject) => {
        return moment(parseInt(cell) * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      dataField: "maker_name",
      text: "Người thực hiện",
    },
    {
      dataField: "to_status",
      text: "Trạng thái",
      formatter: (cell, row, enumObject) => {
        return (
          orderStatusList.find(item => item.value === String(cell))?.label || ""
        );
      },
    },
    {
      dataField: "shipping_history",
      text: "Lịch sử đơn hàng",
      formatter: (cell, row, enumObject) => {
        return (
          <div className="d-flex flex-column gap-1">
            <span className="note-wrap text-primary">{cell}</span>
            {row?.note && (
              <span className="note-wrap">Ghi chú: {row?.note}</span>
            )}
          </div>
        );
      },
    },
  ];
  return (
    <>
      <RemoteDataTable
        keyField="id"
        data={orderHistoryList || []}
        searchSticky
        columns={columnTable}
        isShowRowIndex={false}
        isShowSearchAll={false}
        isShowPagination={false}
        classNameTable={"blood-order-history-list-table"}
        loading={isOrderHistoryLoading}
      ></RemoteDataTable>
    </>
  );
};

export default OrderHistoryList;
